import {createRef} from "../createRef";

export default createRef({
    "id": "STAFF_REF",
    "source": "STAFF_REF",
    "fields": [
        {   "column": "code", },
        {   "column": "name", },
    ],
});
